const dateOptions = {
  dateTime: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  },
  /** MM/DD/YYYY with time (e.g. 02/20/2026, 03:45 PM) */
  dateTimeFormatted: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  },
  date: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  },
  /** MM/DD/YYYY date only (no time) */
  dateFormatted: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  },
  time: {
    hour: '2-digit',
    minute: '2-digit',
  },
};

export default dateOptions;
